import { api } from "../../lib/api";
export const getProjectGeofence = async (projectId, queryParams) => {
    const params = new URLSearchParams();
    if ("partyNumber" in queryParams) {
        params.append("partyNumber", queryParams.partyNumber);
    }
    else if ("downSelectPartyNumber" in queryParams) {
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    }
    const { data } = await api.get(`/projects/${projectId}/geofences${params.toString() ? "?" + params.toString() : ""}`);
    return data;
};
export const createProjectGeofence = async (projectId, queryParams, requestBody) => {
    const params = new URLSearchParams();
    if ("partyNumber" in queryParams) {
        params.append("partyNumber", queryParams.partyNumber);
    }
    else if ("downSelectPartyNumber" in queryParams) {
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    }
    const { data } = await api.post(`/projects/${projectId}/geofences${params.toString() ? "?" + params.toString() : ""}`, requestBody);
    return data;
};
export const deleteProjectGeofence = async (projectId, geofenceId, queryParams) => {
    const params = new URLSearchParams();
    if ("partyNumber" in queryParams) {
        params.append("partyNumber", queryParams.partyNumber);
    }
    else if ("downSelectPartyNumber" in queryParams) {
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    }
    const { data } = await api.delete(`/projects/${projectId}/geofences/${geofenceId}${params.toString() ? "?" + params.toString() : ""}`);
    return data;
};
export const updateProjectGeofence = async (projectId, geofenceId, queryParams, requestBody) => {
    const params = new URLSearchParams();
    if ("partyNumber" in queryParams) {
        params.append("partyNumber", queryParams.partyNumber);
    }
    else if ("downSelectPartyNumber" in queryParams) {
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    }
    const { data } = await api.patch(`/projects/${projectId}/geofences/${geofenceId}${params.toString() ? "?" + params.toString() : ""}`, requestBody);
    return data;
};
